import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaArrowLeft, FaCalendarAlt, FaCar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

export default function Calendario({ goBack }) {
    const [vehiculos, setVehiculos] = useState([]);
    const [rentas, setRentas] = useState([]);
    const [mesActual, setMesActual] = useState(new Date());
    const [loading, setLoading] = useState(true);

    // Generar días del mes
    const getDiasDelMes = (fecha) => {
        const year = fecha.getFullYear();
        const month = fecha.getMonth();
        const primerDia = new Date(year, month, 1);
        const ultimoDia = new Date(year, month + 1, 0);
        const dias = [];
        
        for (let d = 1; d <= ultimoDia.getDate(); d++) {
            dias.push(new Date(year, month, d));
        }
        return dias;
    };

    const diasDelMes = getDiasDelMes(mesActual);
    const nombreMes = mesActual.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const v = await axios.get('https://api.alquilacarbolivia.com/api/vehiculos');
            const allRentas = [];
            
            for (let car of v.data) {
                const det = await axios.get(`https://api.alquilacarbolivia.com/api/vehiculos/${car.id}`);
                if (det.data.rentas) {
                    allRentas.push(...det.data.rentas.map(r => ({...r, vehiculo_id: car.id, vehiculo: car})));
                }
            }
            
            setVehiculos(v.data);
            setRentas(allRentas);
        } catch (error) {
            console.error('Error cargando datos:', error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusDia = (carId, fecha) => {
        const ocupado = rentas.find(r => 
            r.vehiculo_id === carId && 
            r.estado === 'activo' &&
            new Date(r.fecha_inicio) <= fecha && 
            new Date(r.fecha_fin) >= fecha
        );

        if (ocupado) return { color: '#ee0979', cliente: ocupado.cliente };
        return { color: '#11998e', cliente: null };
    };

    const cambiarMes = (direccion) => {
        const nuevaFecha = new Date(mesActual);
        nuevaFecha.setMonth(nuevaFecha.getMonth() + direccion);
        setMesActual(nuevaFecha);
    };

    const esHoy = (fecha) => {
        const hoy = new Date();
        return fecha.getDate() === hoy.getDate() && 
               fecha.getMonth() === hoy.getMonth() && 
               fecha.getFullYear() === hoy.getFullYear();
    };

    const esDomingo = (fecha) => fecha.getDay() === 0;

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{minHeight: '100vh'}}>
                <div className="spinner-border text-primary" style={{width: '3rem', height: '3rem'}}></div>
            </div>
        );
    }

    return (
        <div className="container-fluid p-0" style={{background: 'linear-gradient(to bottom, #f8f9fa 0%, #e9ecef 100%)', minHeight: '100vh'}}>
            {/* HEADER MEJORADO */}
            <div className="shadow-lg" style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '20px 30px'
            }}>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <button 
                            className="btn btn-light btn-sm me-3 shadow-sm" 
                            onClick={goBack}
                            style={{borderRadius: '20px', padding: '10px 20px'}}
                        >
                            <FaArrowLeft className="me-2"/> Volver
                        </button>
                        <div className="d-flex align-items-center">
                            <div className="bg-white bg-opacity-25 p-2 rounded-circle me-3">
                                <FaCalendarAlt style={{fontSize: '1.8rem', color: 'white'}}/>
                            </div>
                            <div className="text-white">
                                <h3 className="m-0 fw-bold" style={{letterSpacing: '1px'}}>CALENDARIO DE DISPONIBILIDAD</h3>
                                <small style={{opacity: 0.9}}>{vehiculos.length} vehículos en flota</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-4">
                {/* CONTROLES DE NAVEGACIÓN */}
                <div className="card border-0 shadow-lg mb-4" style={{borderRadius: '20px'}}>
                    <div className="card-body p-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <button 
                                className="btn btn-lg shadow-sm"
                                onClick={() => cambiarMes(-1)}
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '15px',
                                    padding: '12px 25px'
                                }}
                            >
                                <FaChevronLeft className="me-2"/> Mes Anterior
                            </button>
                            
                            <h2 className="fw-bold mb-0" style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                                textTransform: 'capitalize',
                                fontSize: '2rem'
                            }}>
                                📅 {nombreMes}
                            </h2>
                            
                            <button 
                                className="btn btn-lg shadow-sm"
                                onClick={() => cambiarMes(1)}
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '15px',
                                    padding: '12px 25px'
                                }}
                            >
                                Mes Siguiente <FaChevronRight className="ms-2"/>
                            </button>
                        </div>
                    </div>
                </div>

                {/* LEYENDA */}
                <div className="card border-0 shadow-sm mb-4" style={{borderRadius: '20px'}}>
                    <div className="card-body p-3">
                        <div className="d-flex gap-4 justify-content-center align-items-center">
                            <div className="d-flex align-items-center gap-2">
                                <div style={{
                                    width: '30px',
                                    height: '30px',
                                    background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                    borderRadius: '8px'
                                }}></div>
                                <span className="fw-bold">Disponible</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <div style={{
                                    width: '30px',
                                    height: '30px',
                                    background: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
                                    borderRadius: '8px'
                                }}></div>
                                <span className="fw-bold">Ocupado</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <div style={{
                                    width: '30px',
                                    height: '30px',
                                    background: '#ffc107',
                                    borderRadius: '8px',
                                    border: '3px solid #667eea'
                                }}></div>
                                <span className="fw-bold">Día Actual</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* CALENDARIO MEJORADO */}
                <div className="card border-0 shadow-lg" style={{borderRadius: '20px', overflow: 'hidden'}}>
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            {/* ENCABEZADO CON DÍAS */}
                            <thead>
                                <tr style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white'
                                }}>
                                    <th className="fw-bold py-3 px-3" style={{
                                        position: 'sticky',
                                        left: 0,
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        zIndex: 2,
                                        minWidth: '180px'
                                    }}>
                                        <FaCar className="me-2"/> Vehículo
                                    </th>
                                    {diasDelMes.map((fecha, idx) => (
                                        <th 
                                            key={idx} 
                                            className="text-center py-3"
                                            style={{
                                                minWidth: '50px',
                                                background: esDomingo(fecha) ? 'rgba(255,255,255,0.1)' : 'transparent'
                                            }}
                                        >
                                            <div className="fw-bold">{fecha.getDate()}</div>
                                            <small style={{opacity: 0.8, fontSize: '0.7rem'}}>
                                                {fecha.toLocaleDateString('es-ES', { weekday: 'short' })}
                                            </small>
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            {/* CUERPO CON VEHÍCULOS Y DISPONIBILIDAD */}
                            <tbody>
                                {vehiculos.map((car, carIdx) => (
                                    <tr key={car.id} style={{
                                        background: carIdx % 2 === 0 ? 'white' : '#f8f9fa'
                                    }}>
                                        <td className="fw-bold py-3 px-3" style={{
                                            position: 'sticky',
                                            left: 0,
                                            background: carIdx % 2 === 0 ? 'white' : '#f8f9fa',
                                            zIndex: 1,
                                            borderRight: '2px solid #dee2e6'
                                        }}>
                                            <div className="d-flex align-items-center gap-2">
                                                <div style={{
                                                    width: '8px',
                                                    height: '40px',
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    borderRadius: '4px'
                                                }}></div>
                                                <div>
                                                    <div style={{fontSize: '0.95rem', color: '#2d3748'}}>
                                                        {car.marca} {car.modelo}
                                                    </div>
                                                    <small className="text-muted">{car.placa}</small>
                                                </div>
                                            </div>
                                        </td>
                                        {diasDelMes.map((fecha, diaIdx) => {
                                            const status = getStatusDia(car.id, fecha);
                                            const isHoy = esHoy(fecha);
                                            const isDomingo = esDomingo(fecha);
                                            
                                            return (
                                                <td 
                                                    key={diaIdx} 
                                                    className="p-1 text-center position-relative"
                                                    style={{
                                                        cursor: status.cliente ? 'pointer' : 'default',
                                                        background: isDomingo ? '#f8f9fa' : 'transparent'
                                                    }}
                                                    title={status.cliente ? `Ocupado: ${status.cliente}` : 'Disponible'}
                                                >
                                                    <div style={{
                                                        width: '100%',
                                                        height: '50px',
                                                        background: status.color,
                                                        borderRadius: '8px',
                                                        border: isHoy ? '3px solid #ffc107' : 'none',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        transition: 'all 0.3s ease',
                                                        boxShadow: isHoy ? '0 0 15px rgba(255, 193, 7, 0.5)' : 'none'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (status.cliente) {
                                                            e.currentTarget.style.transform = 'scale(1.1)';
                                                            e.currentTarget.style.zIndex = '10';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.transform = 'scale(1)';
                                                        e.currentTarget.style.zIndex = '0';
                                                    }}
                                                    >
                                                        {status.cliente && (
                                                            <span style={{
                                                                color: 'white',
                                                                fontSize: '1.2rem',
                                                                fontWeight: 'bold'
                                                            }}>
                                                                🚗
                                                            </span>
                                                        )}
                                                    </div>
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* ESTADÍSTICAS */}
                <div className="row mt-4 g-3">
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm" style={{
                            borderRadius: '20px',
                            background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                            color: 'white'
                        }}>
                            <div className="card-body p-4 text-center">
                                <h2 className="fw-bold mb-1">
                                    {vehiculos.filter(v => v.estado === 'libre').length}
                                </h2>
                                <div>Vehículos Disponibles Hoy</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm" style={{
                            borderRadius: '20px',
                            background: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
                            color: 'white'
                        }}>
                            <div className="card-body p-4 text-center">
                                <h2 className="fw-bold mb-1">
                                    {vehiculos.filter(v => v.estado === 'ocupado').length}
                                </h2>
                                <div>Vehículos en Renta</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm" style={{
                            borderRadius: '20px',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: 'white'
                        }}>
                            <div className="card-body p-4 text-center">
                                <h2 className="fw-bold mb-1">
                                    {vehiculos.length}
                                </h2>
                                <div>Total en Flota</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');
                * {
                    font-family: 'Poppins', sans-serif;
                }
                
                .table-hover tbody tr:hover {
                    background-color: rgba(102, 126, 234, 0.05) !important;
                }
            `}</style>
        </div>
    );
}